// /mnt/data/TwoColumnLayout.js
import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { useHistory } from "react-router-dom"; // v5
import "./TwoColumnLayout.css";
import { getLang, setLang, LANG_ID, LANG_ZH } from "../utils/language";
import { safeGoBack } from "../utils/wkCommon";

import { useLocation } from "react-router-dom";
import { logVisit } from "../utils/wkCommon";

/**
 * TwoColumnLayout (header styled like ContentLayout)
 */
export default function TwoColumnLayout({
  leftNode,
  rightNode,
  variant = "right60",
  title = "",
  showBack = true,
  onBack,
  headerActions = null,
  layoutClass = "", // untuk class specific agar tidak conflict dengan page lainnya
  hideLangSwitch = false
}) {
  const history = useHistory();
  const isRight60 = variant === "right60";
  const oneColumn = variant === "oneColumn";

  const location = useLocation();

  useEffect(() => {
    logVisit({
      path: location.pathname,
      query: location.search,
    });
  }, [location.pathname]);
    
  const [lang, setLangState] = React.useState(getLang());

  function toggleLang() {
    const newLang = lang === LANG_ZH ? LANG_ID : LANG_ZH;
    setLang(newLang);
    window.location.reload();
  }

  return (
    <div className={`two-col-root ${layoutClass}`}>
      {/* header: use same structure as ContentLayout for consistent look */}
      <header className="content-header twocol-header-bleed">
        <div className="header-inner">
          <div className="header-left">
            {showBack && (
              <button
                className="btn-icon back-btn"
                onClick={() => safeGoBack(history)}
                aria-label="Back"
              >
                {/* SVG same direction/size as ContentLayout */}
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="20" height="20" fill="currentColor" aria-hidden="true">
                  <path fillRule="evenodd" d="M7.72 12.53a.75.75 0 0 1 0-1.06l7.5-7.5a.75.75 0 1 1 1.06 1.06L9.31 12l6.97 6.97a.75.75 0 1 1-1.06 1.06l-7.5-7.5Z" clipRule="evenodd" />
                </svg>
              </button>
            )}
            <div className="page-title twocol-page-title">{title}</div>
          </div>

          <div className="header-right">
            {!hideLangSwitch && (
              <button className="btn-icon" onClick={toggleLang} title="切換語言 Ubah Bahasa">
                {lang === LANG_ZH ? "ID" : "文"}
              </button>
            )}

            {headerActions === undefined ? (
              <>
                <button className="btn-icon add-btn" title="Add">＋</button>
                <button className="btn-icon more-btn" title="More">⋯</button>
              </>
            ) : (
              headerActions
            )}
          </div>
        </div>
      </header>

      {oneColumn ? (
        <div className={`one-col-container`}>
          <div className="one-col">
            {rightNode}
          </div>
        </div>
      ) : (
        <div className={`two-col-container ${isRight60 ? "right-60" : ""}`}>
          <div className="two-col-left">
            {leftNode}
          </div>
          <div className="two-col-right">
            {rightNode}
          </div>
        </div>
      )}
    </div>
  );
}

TwoColumnLayout.propTypes = {
  leftNode: PropTypes.node,
  rightNode: PropTypes.node,
  variant: PropTypes.string,
  title: PropTypes.string,
  showBack: PropTypes.bool,
  onBack: PropTypes.func,
  headerActions: PropTypes.node,
};
